import { logInfo } from 'src/utils/logger';

const statusNotification = require('../../status');

module.exports = {
  initialize: function () {
    _.bindAll(this, 'execute', 'request', 'download');
  },

  getDefaultOptions: function () {
    return {
      getUrlResponse: true,
      format: 'jpeg',
      baseUrl: INKIVE.C.BASE_URL,
      staticUrl: INKIVE.C.STATIC_URL
    };
  },

  getDefaultParameters: function () {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;

    return {
      bleed: 'n',
      book_id: INKIVE.C.BOOK.id,
      cmyk: 'n',
      end_page: INKIVE.Tool._current_page_number,
      forced_transparency: 'n',
      format: 'jpeg',
      height: canvas.contentH,
      is_zip: 'n',
      quality: 80,
      start_page: INKIVE.Tool._current_page_number,
      width: canvas.contentW
    };
  },

  download: function (callback, opts, params) {
    INKIVE.UserInfoFactory.canConsume('download', false).then(
      () => _download.call(this),
      () => _displayNoActionsLeftError());

    function _download () {
      opts = opts || this.getDefaultOptions();
      params = params || this.getDefaultParameters();
      callback = callback || $.noop;

      const request = this.request;

      $('body > header > .options button[data-action="download"]')
        .addClass('disabled');

      INKIVE.FormatFactory.getCurrentFormat().then(_.bind(function (format) {
        format = format || INKIVE.FormatFactory.getCurrentSize();
        if (format.unit) {
          params.initial = format;
          this._getScaleFactor(params);
        }

        logInfo('Print Bleed Info: downloadProcedure -> download() final data', { params, opts });

        INKIVE.DesygnerApi.post(`business/projects/${INKIVE.C.BOOK.id}/download`, params).then((r) => {
          statusNotification.display(INKIVE.TranslateHelper.translate('general.preparing_download'), null, true);
          const data = Array.isArray(r) ? r : JSON.parse(r);

          if (data) {
            _.each(data, function (url) {
              if (INKIVE.Helpers.isUrlValid(url)) {
                const urlRequest = opts.getUrlResponse
                  ? _.partial(request, url, params, callback)
                  : _.partial(request, url, params);

                _.delay(urlRequest, 3000);
              }
            });
            const flag = true;
            opts.getUrlResponse || callback(flag);
          } else {
            onError();
          }
        })
        .catch(onError);

        function onError (data) {
          const message = !data
            ? INKIVE.TranslateHelper.translate('modal.alert.can_not_prepare_file', {
              format: opts.format
            })
            : data;

          INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
              message: message,
              try_again: !data
            }
          ));
          const flag = false;
          callback(flag);
        }
      }, this));
    }

    async function _displayNoActionsLeftError () {
      const workspace = await INKIVE.CompanyFactory.getCompanyData();

      INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
        message: INKIVE.TranslateHelper.translate('modal.alert.no_actions_left', {
          company_name: workspace.name
        })
      }));
      callback(false);
    }
  },

  execute: function ($wrapper, opts, callback) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;

    opts = $.extend({
      format: null,
      contentW: null,
      contentH: null,
      pageRange: null,
      baseUrl: INKIVE.C.BASE_URL,
      staticUrl: INKIVE.C.STATIC_URL
    },
    opts);

    this.notification(true);
    const params = {
      book_id: INKIVE.C.BOOK.id,
      pages: JSON.stringify(opts.selectedPages),
      forced_transparency: $wrapper.find('[name=isForcedTransparency]').is(':checked') ? 'y' : 'n',
      bleed: $wrapper.find('[name=isBleed]').is(':checked') ? 'y' : 'n',
      cutmarks: $wrapper.find('[name=isCutmark]').is(':checked') ? 'y' : 'n',
      is_zip: $wrapper.find('[name=isZip]').is(':checked') || (INKIVE.C.IS_MOBILE_APP && !window.Android) ? 'y' : 'n',
      format: opts.format,
      cmyk: $wrapper.find('[name=isCMYK]').is(':checked') ? 'y' : 'n'
    };

    const book = INKIVE.C.BOOK || {};
    logInfo('Print Bleed Info: downloadProcedure -> execute() initial data', { params, opts, book });

    if (params.bleed === 'y') {
      canvas.runExtensions('generateNewBleed', {});

      params.bleed_type = 'manual';
      params.bleed_amount = INKIVE.C.BLEED_VALUES.bleedSize || '15 15 15 15';
      params.bleed_unit = INKIVE.C.BLEED_VALUES.bleedUnit || 'px';
      params.slug_unit = params.bleed_unit;
      params.slug_amount = canvas.runExtensions('getSlugValues');
    } else if ($wrapper.find('[name=isAutomaticBleed]').is(':checked')) {
      params.bleed_type = 'auto';
      params.bleed = 'y';
      params.bleed_unit = INKIVE.C.BLEED_VALUES.bleedUnit || 'px';
    }

    if ($wrapper.find('a.quality.active').length) {
      params.quality = $wrapper.find('a.quality.active').attr('data-value');
    } else if ($wrapper.find('.quality-slider').length) {
      params.quality = $wrapper.find('.quality-slider').slider('option', 'value');
    } else {
      params.quality = opts.quality;
    }

    params.width = $wrapper.find('.rangeCurrentDimensions[data-type="width"]').val() || opts.contentW;
    params.height = $wrapper.find('.rangeCurrentDimensions[data-type="height"]').val() || opts.contentH;

    params.has_filter = $('#svgcontent').find('image[filter]').length > 0 ? 'y' : 'n';

    const startPage = opts.selectedPages[0];
    const finalPage = opts.selectedPages.length;

    // If less than 2 pages are selected (for jpg or png format) the download file will be a .JPG or .PNG
    // If  more than 1 page is selected all the files will be downloaded as a ZIP
    if (finalPage < 2) {
      params.is_zip = 'n';
    }

    if (opts.format === 'pdf') {
      params.start_page = startPage || 1;
      params.end_page = finalPage || INKIVE.C.BOOK.num_pages;
    } else {
      params.start_page = startPage || 1;
      params.end_page = finalPage || INKIVE.C.BOOK.num_pages;
    }

    if (opts.downloadType === 'quickDownload') {
      params.quality = 60;
    }

    _.each(['thumb', 'web', 'mobile'], function (platform) {
      if ($wrapper.find('[name=is' + platform.charAt(0).toUpperCase() + platform.slice(1) + ']').is(':checked')) {
        params[platform + '_width'] = $wrapper.find('.' + platform + 'Dimensions[data-type="width"]').val();
        params[platform + '_height'] = $wrapper.find('.' + platform + 'Dimensions[data-type="height"]').val();
      }
    });

    logInfo('Print Bleed Info: downloadProcedure -> execute() final data', { params, opts, book });

    this.download(callback, opts, params);
  },

  notification: function (isDownload) {
    $('#ik-download-notification').toggle(isDownload);
    $('a[data-id="download"]').toggle(!isDownload);
  },

  request: function (url, params, callback) {
    let tryCount = 0;
    let numAttemptsStatic = 30;
    const numAttemptsDynamic = INKIVE.C.BOOK.num_pages * 3;
    let attemptInterval = 2500;

    if (numAttemptsDynamic > numAttemptsStatic) {
      numAttemptsStatic = numAttemptsDynamic;
    }

    if (numAttemptsStatic > 90) {
      numAttemptsStatic = 90;
    }

    if (params.cmyk === 'y') {
      numAttemptsStatic += 8;
    }
    if (params.bleed === 'y') {
      numAttemptsStatic += 8;
    }
    if (params.quality === 'print') {
      numAttemptsStatic += 8;
    }

    $('#svgcontent').find('image').each(function () {
      numAttemptsStatic++;
    });

    const finishDownloadProcess = function (message) {
      statusNotification.display(message);

      $('body > header > .options button[data-action="download"]')
        .removeClass('disabled');
    };

    const refreshId = setInterval(_.bind(function () {
      INKIVE.Helpers.api('inkive/fileexists', 'GET', { url: url }, _.bind(function (r) {
        if (r && r.status === 'success' && r.exists) {
          this.notification();
          clearInterval(refreshId);

          if (INKIVE.C.IS_MOBILE_APP) {
            AppBridge.callBoth('catch_file', {
              url: url,
              page: INKIVE.Tool._current_page_number
            });
          } else {
            finishDownloadProcess(INKIVE.TranslateHelper.translate('general.download_ready'));

            callback
              ? callback(url)
              : INKIVE.Helpers.saveToDisk(url);
          }
        }
      }, this));

      if (tryCount === 60) attemptInterval = 3000;

      if (tryCount > numAttemptsStatic) {
        this.notification();

        INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
          message: 'modal.alert.network',
          check_network: true
        })
        );

        finishDownloadProcess(INKIVE.TranslateHelper.translate('common.error'));

        clearInterval(refreshId);
      }

      tryCount++;
    }, this), attemptInterval);
  },

  _getScaleFactor: function (params) {
    const svgWidth = params.width;
    const svgHeight = params.height;
    let templateWidth = params.initial.width;
    let templateHeight = params.initial.height;

    switch (params.initial.unit) {
      case 'mm':
        templateWidth = templateWidth * INKIVE.C.DPI / 25.4;
        templateHeight = templateHeight * INKIVE.C.DPI / 25.4;
        break;

      case 'cm':
        templateWidth = templateWidth * INKIVE.C.DPI / 2.54;
        templateHeight = templateHeight * INKIVE.C.DPI / 2.54;
        break;

      case 'in':
        templateWidth = templateWidth * INKIVE.C.DPI;
        templateHeight = templateHeight * INKIVE.C.DPI;
        break;
    }

    const scaleWidth = templateWidth / svgWidth;
    const scaleHeight = templateHeight / svgHeight;
    const scaleFactor = scaleWidth || scaleHeight;

    params.scale = Math.round(scaleFactor * 1000) / 1000;

    if (params.scale !== 1) {
      params.scale = Math.round(scaleWidth * 10000000) / 10000000;
    }
  }
};
